import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

/** Separate strokes keep the horizontal minus still when the accordion opens. */
export default function PlusMinusIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      className={`signal-plus-minus ${props.className ?? ''}`}
      viewBox="0 0 24 24"
      sx={[
        ...(Array.isArray(props.sx) ? props.sx : props.sx ? [props.sx] : []),
        { fill: 'none', stroke: 'currentColor', strokeWidth: 1.75, strokeLinecap: 'round' },
      ]}
    >
      <path d="M5 12h14" />
      <path d="M12 5v14" />
    </SvgIcon>
  );
}
